/* RESPONSIBLE TEAM: team-knowledge-foundations */
import GlobalLoadingRoute from 'embercom/routes/base/global-loading-route';

export default GlobalLoadingRoute.extend();
